import React from 'react';
import { ReactNode } from 'react';
import LaunchIcon from '@mui/icons-material/Launch';

interface StatsCardProps {
  icon: ReactNode;
  title: string;
  value: string | number;
  onViewDetails?: () => void;
  onClickAction?: () => void;
}

const StatsCard: React.FC<StatsCardProps> = ({ 
  icon, 
  title, 
  value, 
  onViewDetails,
  onClickAction
}) => {
  return (
    <div className='bg-white rounded-xl p-6 shadow-sm'>
      <div className='flex items-start justify-between mb-2'>
        <div className='flex items-center gap-3'>
          <div className='w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center'>
            {icon}
          </div>
          <div>
            <p className='text-sm text-gray-600'>{title}</p>
            <p className='text-2xl font-bold text-gray-900'>{value}</p>
          </div>
        </div>
        {onViewDetails && (
          <button 
            className='p-1 hover:bg-gray-100 rounded'
            onClick={onViewDetails}
          >
            <LaunchIcon fontSize='small' className='text-gray-600'  onClick={onClickAction}/>
          </button>
        )}
      </div>
    </div>
  );
};

export default StatsCard;
